<template>
  <div class="register-organizer-1">
    <div slot="title" class="row">
      <div class="col-sm-12">
        <h3 class="text-center form-title">Fundraiser Registration</h3>
      </div>
      <div class="col-sm-12">
        <p class="text-center">Register to create a fundraiser</p>
      </div>
    </div>

    <div class="row" :class="form.errors.has('internalError') ? ' has-error' : ''">
      <div class="col-md-12 form-group margin-bottom-30">
        <span class="black-title margin-0">Login Information</span>
        <span class="help-block" v-if="form.errors.has('internalError')">
          <strong>Something went wrong. Please try again later.</strong>
        </span>
      </div>
    </div>
    <iframe name="formSubmitFrame" rel="nofollow" class="hidden"></iframe>
    <form
      action="https://helpahero.us20.list-manage.com/subscribe/post?u=28496bc2d2b229bbc1c44894b&amp;id=a66433d40d&amp;f_id=006e53e6f0"
      method="post" id="mc-embedded-subscribe-form-organizer" name="mc-embedded-subscribe-form" class="validate"
      target="formSubmitFrame">
      <input type="hidden" :value="form.email" name="EMAIL" class="required email" id="mce-EMAIL" required>
      <input type="hidden" :value="form.first_name" name="FNAME" class="" id="mce-FNAME">
      <input type="hidden" :value="form.last_name" name="LNAME" class="" id="mce-LNAME">
      <!-- 'organizer' tag-->
      <div hidden="true"><input type="hidden" name="tags" value="1643302"></div>
      <div id="mce-responses" class="clear foot">
        <div class="response" id="mce-error-response" style="display:none"></div>
        <div class="response" id="mce-success-response" style="display:none"></div>
      </div>
      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
          name="b_28496bc2d2b229bbc1c44894b_a66433d40d" tabindex="-1" value=""></div>
    </form>

    <form @submit.prevent="onCaptchaExecute" action="#" class="row organizer-form">

      <div class="margin-top-20 margin-bottom-20 col-sm-12">
        <div class="row">
          <div class="form-group col-sm-12">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="form.email"
              placeholder="Email address"
              autocomplete="cc-name"
            />
            <div class="form-group">
              <div class="hint-text">
                A verification email will be sent to this address
              </div>
            </div>
            <div class="form-group">
                <div class="checkbox-wrapper">
                    <checkbox v-model="subscribe"/>
                    <div class="hint-text">Subscribe to our newsletter</div>
                </div>
            </div>

              <div
                class="invalid-feedback-red"
                v-if="form.errors.has('email')"
              >
                {{ form.errors.get("email") }}
              </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-6">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="form.first_name"
              placeholder="First name"
              autocomplete="cc-name"
            />

              <div
                class="invalid-feedback-red"
                v-if="form.errors.has('first_name')"
              >
                {{ form.errors.get("first_name") }}
              </div>
          </div>
          <div class="form-group col-sm-6">
            <input-label
              type="text"
              css-class="form-control"
              required
              v-model="form.last_name"
              placeholder="Last name"
              autocomplete="cc-name"
            />

              <div
                class="invalid-feedback-red"
                v-if="form.errors.has('last_name')"
              >
                {{ form.errors.get("last_name") }}
              </div>
          </div>
        </div>

        <div class="row margin-top-10">
          <div class="form-group col-sm-12 password-step-1">
            <password-container
              v-model="form.password"
              autocomplete="nope"
              placeholder="Enter Password"
              label="Password"
              :required="true"
              :withLabel="true"
              role="organizer"
            />

              <div class="invalid-feedback-red"
                v-if="form.errors.has('password')"
              >
                {{ form.errors.get("password") }}
              </div>
          </div>
        </div>

        <div class="row margin-top-10">
          <div class="form-group col-sm-12">
            <password-container
              v-model="form.password_confirmation"
              autocomplete="nope"
              label="Confirm password"
              placeholder="Confirm password"
              :required="true"
              :show-hint="false"
              :withLabel="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <vue-recaptcha
                class="g-recaptcha"
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                size="invisible"
                badge="inline"
                :sitekey="recaptchaSiteKey"
            >
            </vue-recaptcha>

            <div
                class="invalid-feedback-red"
                v-if="form.errors.has('recaptcha_token')"
            >
              {{ form.errors.get("recaptcha_token") }}
            </div>
          </div>
        </div>
      </div>

      <div class="section-footer margin-top-10">
      <div class="form-group col-sm-12">
        <button
            type="submit"
            id="registerByEmailBtn"
            class="btn hh-btn hh-btn-green col-md-12" name="Send email verification">
            Send Email Verification
          </button>
      </div>
        <div class="form-group row margin-top-10">
          <div class="col-sm-12 form-agreement-text text-center margin-top-10">
            <p class="">
              By registering your account, you agree to our
              <a href="/terms">Services Agreement</a> and the
              <a href="https://stripe.com/connect-account/legal" target="_blank" rel="noopener"
                >Stripe Connected Account Agreement</a>.
            </p>
          </div>
        </div>

        <div class="row hh-cta-link form">
          <div class="col-md-12 no-padding text-center">
            <p>
              Already have an account? <a class="cta-link" href="/login">Login here</a>
            </p>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import InputLabel from "../../../components/form/elements/InputLabel";
import PasswordContainer from "../../../components/form/elements/PasswordContainer";
import Form from '../../../plugins/hh-form.js'
import VueRecaptcha from 'vue-recaptcha'
import constants from "../../../config";
import Checkbox from "../../../components/form/elements/Checkbox.vue";

export default {
  name: "Step-1",

  components: {
    InputLabel,
    PasswordContainer,
    'vue-recaptcha': VueRecaptcha,
    Checkbox
  },

  props: {
    userData: {
      email: String,
      first_name: String,
      last_name: String,
    },
    config: Object,
    userRoles: Array,
    identities: Array,
  },

  data() {
    return {
      loading: true,
      recaptchaSiteKey: null,
      subscribe: true,
      form: new Form({
        email: null,
        first_name: null,
        last_name: null,
        password: null,
        password_confirmation: null,
        role: "organizer",
        recaptcha_token: null,
        opType: "create",
        step: 1,
      }, this.$api),
    }
  },

  beforeMount() {
    this.recaptchaSiteKey = constants.RECAPTCHA_INVISIBLE_SITE_KEY
    this.form.first_name = this.userData.first_name
    this.form.last_name = this.userData.last_name

    this.loading = false
  },

  mounted() {},

  methods: {
    ...mapActions('fundraiser', ['register']),

    async submit() {
      this.loading = true

      if (!_.isEmpty(this.userData.email)) {
        this.form.opType = 'update'
      }

      await this.register(this.form)

      if (this.form.errors.any()) {
        this.onCaptchaExpired()
        this.loading = false
        return false
      }

      this.$emit("formSubmitted")

      if (this.subscribe) {
        document.getElementById("mc-embedded-subscribe-form-organizer").requestSubmit();
      }

      this.loading = false
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value
    },

    onCaptchaVerified: async function (recaptchaToken) {
      this.form.recaptcha_token = recaptchaToken
      await this.submit()
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaExecute() {
      this.$refs.recaptcha.execute()
    },
  },

  computed: {

  },

  watch: {
    loading(to, from) {
      this.$emit("componentLoading", "stepComponent", to)
    },
  },
};
</script>

<style lang="scss" scoped>
.register-organizer-1 {
  hr {
    border: 1px solid whitesmoke;
  }

  .invalid-feedback-red {
    display: block;
    color: rgb(188, 46, 46);

    i {
      margin-right: 10px;
    }
  }

  .organizer-form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hint-text {
    font-size: 14px;
    color: #b2b2b2;
  }

  .hh-btn-green {
    padding: 20px;
    width: 100%;
  }

  .form-title {
    color: black;
  }
}

  .g-recaptcha::v-deep {
      margin-right: -65px;
  }

  .recaptcha-wrapper {
      margin-left: 15px;
      width: 55%;
  }

  @media screen and (max-width: 991px ) {
    .recaptcha-wrapper {
        width: 80% !important;
        margin-left: 15px;
    }
  }

  .checkbox-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
</style>